import { render, staticRenderFns } from "./services-details.vue?vue&type=template&id=2aa0a2e3&scoped=true&"
import script from "./services-details.vue?vue&type=script&lang=js&"
export * from "./services-details.vue?vue&type=script&lang=js&"
import style0 from "./services-details.vue?vue&type=style&index=0&id=2aa0a2e3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0a2e3",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-details.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/search.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-details.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "@/lang/confirmations.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-details.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports